// Module-level live screen-share session so it survives Copilot unmount/remount.
const s = {
  stream: null,
  lost: false,
  autoScan: false,
  result: null,
  alerts: [],
  liveLog: [],
  liveAlert: null,
  scanCount: 0,
  lastScanAt: null,
  lastRef: null,
  broker: null,
  brokerSessionId: null,
  voiceLoop: false,
  symbol: "",
  timeframe: "",
  note: "",
  limitHit: false,
  listeners: new Set(),
};

const emit = () => s.listeners.forEach((fn) => fn(liveSession.snapshot()));

export const liveSession = {
  get: () => s,
  snapshot: () => ({ active: liveSession.isActive(), lost: s.lost, autoScan: s.autoScan, scanCount: s.scanCount }),
  isActive: () => !!s.stream && s.stream.getVideoTracks().some((t) => t.readyState === "live"),
  set(patch) { Object.assign(s, patch); emit(); },
  setStream(stream) {
    s.stream = stream;
    s.lost = false;
    if (stream) {
      const track = stream.getVideoTracks()[0];
      if (track) track.addEventListener("ended", () => { if (s.stream === stream) { s.stream = null; s.lost = true; emit(); } });
    }
    emit();
  },
  stop() {
    s.stream?.getTracks().forEach((t) => t.stop());
    Object.assign(s, { stream: null, lost: false, autoScan: false, voiceLoop: false, lastRef: null, scanCount: 0, lastScanAt: null, liveAlert: null, limitHit: false });
    emit();
  },
  clearLost() { s.lost = false; emit(); },
  subscribe(fn) { s.listeners.add(fn); fn(liveSession.snapshot()); return () => s.listeners.delete(fn); },
};
